// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__31o2n","nowplayingbar":"footer_nowplayingbar__3GUIw","footerMid":"footer_footerMid__2A6B5"};